import React, {useState, useEffect} from 'react'
import {useTranslation} from 'react-i18next';
import MateInfo from './component/MateInfo'
import DeviceInfo from './component/DeviceInfo'
import MateService from '../../../../services/MateService/MateService';
import {Paper, Dialog} from '@material-ui/core';
import {useSetRecoilState} from 'recoil';
import {alertState} from '../../../../recoil-store/recoil-state';
import './MateDetail.css'

function MateDetail(props) {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [isDeviceInfo, setIsDeviceInfo] = useState(false);
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        const id = props.id;
        let response = await MateService.getMateByID(id);
        if (response.status) {
            setData(response.data[0]);
        } else {
            setAlert(alert => ({...alert, show: true, message: t(response.message), severity: 'error'}))
        }
        setLoading(false);
    }

    return (
        <Dialog open={true} className='mate-detail-modal'>
            {!loading &&
            <Paper className='mate-detail-container'>
                <div className="underline-tabs">
                    <button
                        className={!isDeviceInfo ? 'underline-active' : ''}
                        onClick={() => setIsDeviceInfo(prev => !prev)}>
                        {t('CONTENT.MY-MATES.MATE.MATE-TITLE')}
                    </button>
                    <div className="right-side-seperator"/>
                    <button
                        className={isDeviceInfo ? 'underline-active' : ''}
                        onClick={() => setIsDeviceInfo(prev => !prev)}>
                        {t('CONTENT.MY-MATES.DEVICE.DEVICE-DETAIL-TITLE')}
                    </button>
                </div>
                <div>
                    {isDeviceInfo ? <DeviceInfo data={data}/> : <MateInfo data={data}/>}
                </div>
                <div className="button-row">
                    <button className="close-button" onClick={() => props.setShowDetail(false)}>
                        {t("CONTENT.AUTOMS-LIST.CLOSE")}
                    </button>
                </div>
            </Paper>
            }
        </Dialog>
    )
}

export default MateDetail;
